export default "__VITE_ASSET__CvGHbIX6__"